var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.65 21.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffff;stroke-miterlimit:10;stroke-width:0.5px;}.cls-2{fill:#e8432a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.25,
    y: 0.25,
    width: 21.15,
    height: 21.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.52,11.84a6.56,6.56,0,0,1-1-.2,1.07,1.07,0,0,0-1.09.27l-.6.59A6.78,6.78,0,0,1,9.15,9.78l.59-.59A1.12,1.12,0,0,0,10,8.09a4.56,4.56,0,0,1-.2-1,1.09,1.09,0,0,0-1.09-1H7.25a1.07,1.07,0,0,0-1.09,1.1v.1a8.94,8.94,0,0,0,2.6,5.53,9,9,0,0,0,2.5,1.77,9.17,9.17,0,0,0,3,.83,1.1,1.1,0,0,0,.85-.28,1.12,1.12,0,0,0,.35-.81V12.93A1.09,1.09,0,0,0,14.52,11.84Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.6ef28bfbb533238a0e3ab23824ee260f.svg";
export { ForwardRef as ReactComponent };